import React, { Component } from "react";
import PropTypes from "prop-types";
import DynamicGrid from "../DynamicGrid";

const Settings = {
	ShowDateFilter: false,
	SortColumn: "date_out_of_service",
	UseTicketTypeFilter: false,
};

class OutOfService extends Component {
	constructor(props) {
		super(props);
		this.state = {
			Elevators: [],
		};
		this.getData();
	}
	async getData() {
		var url = "Building/GetOutOfServiceElevators";
		const data = await fetch(url, {
			method: "Post",
			cache: "no-cache",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({}),
		});
		var res = await data.json();
		this.setState({ Elevators: res });
	}
	render() {
		var config = [
			{ header: "Building Name", columnName: "building_name", visible: true, typeCode: "S" },
			{ header: "Serial Number", columnName: "serial_number", visible: true, typeCode: "S" },
			{ header: "Date Out of Service", columnName: "date_out_of_service", visible: true, typeCode: "D" },
		];

		return (
			<div style={{ flex: 1, backgroundColor: "#ebebeb", overflowY: "auto", padding: "4px" }}>
				<DynamicGrid Title="Out of Service" Configuration={config} DataSet={this.state.Elevators} Settings={Settings} />
			</div>
		);
	}
}

OutOfService.propTypes = {
	BuildingID: PropTypes.string,
};

export default OutOfService;
